import { getCloverApiHostname } from 'util/Environment';

export const CLIENT_PATH = 'online-ordering';
export const HOSTNAME = getCloverApiHostname();
export const SERVER_PATH = 'oloservice/v1/merchants';
export const SERVER_PATH_BASIC = 'oloservice/v1';
